import type { TypeInfo } from "@moment/api-collab/differential/schema";

import { useConfirmDialog } from "../ConfirmDialog";

export const useConfirmColumnTypeChange = () => {
	const { confirm } = useConfirmDialog();

	const columnTypeChangeConfirmation = ({ toType }: { toType: TypeInfo["enrichedType"] }) => {
		return confirm({
			headingTitle: "Change column type",
			content: (
				<>
					<strong>Permanently delete all the data in this column</strong> and set its type
					to <code className="font-medium">{toType}</code>? This action cannot be
					reversed.
				</>
			),
			variant: "negative",
			confirmLabel: "Delete data and change type",
		});
	};

	return columnTypeChangeConfirmation;
};
